import { UsersTenantResponseDto } from "@o2-fe/api";
import { SprintDuration } from "../models/sprint-duration.enum";

/**
 * Tenant interface with properly typed sprint configuration
 * This extends the API DTO but overrides the sprint property with our local enum
 */
export interface Tenant extends Omit<UsersTenantResponseDto, "sprint"> {
  sprint?: SprintDuration;
}

/**
 * Maps a TenantResponseDto from the API to our local Tenant interface
 * This ensures the sprint property is properly typed as our enum
 */
export function mapTenantFromDto(dto: UsersTenantResponseDto): Tenant {
  return {
    ...dto,
    sprint: dto.sprint as SprintDuration,
  };
}
